/**
 * Restaurant-analytics pivot: My Prices + Analytics first; platform marketplace UI hidden.
 *
 * Enabled by default. Set VITE_PIVOT_MODE=false to restore legacy nav/cabinet surfaces.
 */
export const isPivotModeEnabled = (): boolean => import.meta.env.VITE_PIVOT_MODE !== 'false'
